import React, { useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  Spinner,
  InputGroup,
  Input,
  
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  Badge,
  FormGroup,
} from "reactstrap";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import { useDispatch } from "react-redux";
import { HiEye } from "react-icons/hi";
import { getDescription } from "../../utils/common";

function NotificationList() {
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [focusAfterClose, setFocusAfterClose] = useState(true);
  const [counting, setCounting] = useState({});
  const pageSize = 10;
  const [messageStatus, setMessageStatus] = useState("all");
  const [loader, setLoader] = useState(false);
  const [notificationContent, setNotificationContent] = useState("");

  const fetchAllNotification = async (pageNumber = currentPage, status = "") => {
    try {
      setLoader(true);
      const getAllData = await ApiClient.get(
        `api/users/get-notification?page=${pageNumber}&limit=${pageSize}&status=${status}`,
        "",
        true,
        dispatch
      );
      setNotificationData(getAllData.body.result);
      setCounting(getAllData.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAllNotification(currentPage, messageStatus);
  }, [currentPage, messageStatus]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const toggle = () => setOpen(!open);

  const viewDetails = async (data) => {
    toggle();
    setNotificationContent(data.content);
    await ApiClient.put(`api/users/update-notification-status/${data._id}`,
      {
        id: data._id,
      },
      true,
      dispatch
    );
    fetchAllNotification(currentPage, messageStatus);
  };

  const handleChange = (e) => {
    setMessageStatus(e.target.value)
  }

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="5 "></Col>
                  <Col md="4">
                   
                  </Col>
                  <Col md="3">
                  <FormGroup>
                      <Input
                        type="select"
                        name="gender"
                        id="gender"
                        value={messageStatus}
                        onChange={handleChange}
                      >
                        <option value="all">All Notification</option>
                        <option value="read">Read</option>
                        <option value="unread">Unread</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Content</th>
                          <th>time</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notificationData?.map((data) => (
                          <tr key={data._id}>
                            <td>{data?.title}</td>
                            <td>{getDescription(data?.content)}</td>
                            <td>{data?.timeAgo}</td>
                            <td>
                              {" "}
                              {data?.isRead ? (
                                <Badge color="success" pill>
                                  read
                                </Badge>
                              ) : (
                                <Badge color="warning" pill>
                                  unread
                                </Badge>
                              )}
                            </td>
                            <td className="text-center">
                              <span
                                className="action-icon"
                                onClick={() => viewDetails(data)}
                              >
                                <HiEye />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <span className="mx-3">
                        <strong>Total records: </strong>
                        {counting?.totalRecords}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          returnFocusAfterClose={focusAfterClose}
          isOpen={open}
          centered={true}
        >
          <ModalBody>{notificationContent}</ModalBody>
          <ModalFooter>
            <Button onClick={toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default NotificationList;
